import { UpdateContactTitleComponent } from './update-contact-title/update-contact-title.component'
import { CreateContactTitleComponent } from './create-contact-title/create-contact-title.component'
import { ContactTitlesComponent } from './contact-titles.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const contactTitlesRoutes: Routes = [
  {
    path: 'admin/contact-titles',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'SYSTEM_MANAGEMENT_PANEL',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: ContactTitlesComponent,
        data: {
          permissions: {
            only: 'SYSTEM_MANAGEMENT_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreateContactTitleComponent,
        data: {
          permissions: {
            only: 'SYSTEM_MANAGEMENT_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateContactTitleComponent,
        data: {
          permissions: {
            only: 'SYSTEM_MANAGEMENT_PANEL',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
